export default defineNuxtPlugin((nuxtApp) => {
    let seq = 0

    const markReady = () => {
        seq++
        document.documentElement.setAttribute('data-nuxt-ready', '1')
        ;(window as any).__NUXT_READY__ = true
    }

    nuxtApp.hook('app:mounted', markReady)
})
